import { apiClient, API_PRX } from '@indipia/shared';

export interface NoticeItem {
  noticeId: number;
  noticeTitle: string;
  iconType: string | null;
  publishDtm: string | null;
  isNew: boolean;
  isRead: boolean;
}

export interface NoticeDetail extends NoticeItem {
  noticeContent: string | null;
}

function mapItem(raw: Record<string, unknown>): NoticeItem {
  return {
    noticeId:    (raw['noticeId']    ?? raw['notice_id'])                as number,
    noticeTitle: (raw['noticeTitle'] ?? raw['notice_title'])             as string,
    iconType:    ((raw['iconType']   ?? raw['icon_type']  ?? null))     as string | null,
    publishDtm:  ((raw['publishDtm'] ?? raw['publish_dtm'] ?? null))    as string | null,
    isNew:       ((raw['isNew']      ?? raw['is_new']  ?? false))       as boolean,
    isRead:      ((raw['isRead']     ?? raw['is_read'] ?? false))       as boolean,
  };
}

export async function fetchNotices(): Promise<NoticeItem[]> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/notices`, { params: { limit: 100 } });
  const list = (res.data?.data ?? []) as Record<string, unknown>[];
  return list.map(mapItem);
}

export async function fetchNoticeDetail(noticeId: number): Promise<NoticeDetail> {
  const res = await apiClient.get(`${API_PRX.INDIPIA}/notices/${noticeId}`);
  const raw = res.data?.data as Record<string, unknown>;
  return {
    ...mapItem(raw),
    noticeContent: ((raw['noticeContent'] ?? raw['notice_content']) ?? null) as string | null,
  };
}

export async function markNoticeRead(noticeId: number): Promise<void> {
  await apiClient.patch(`${API_PRX.INDIPIA}/notices/${noticeId}/read`);
}
